import React, { useState, useEffect, useMemo } from "react";
import "./addProperty.css";
import toast from "react-hot-toast";
import { uploadAndCreateImageEntry } from "../../../../../utils/createImgforLots";
import { uploadAndCreateDocumentEntry } from "../../../../../utils/createPdfforLot";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../../../redux/actions/modalActions";
import { fetchLots } from "../../../../../redux/actions/immobilierActions";
import mainAxios from "../../../../../redux/api/mainAxios";
import { useSelector } from "react-redux";
import { fetchInitialData } from "../../../../../redux/actions/deepsearchActions";
import { customStyles, createPaginationState, getVisibleOptions, handleScrollToBottom, handleInputChange } from "../../../componnents/deepsearchUtils";
import Select from "react-select";

const AjouterLot = () => {
  const dispatch = useDispatch();
  const { lieu, promoteur, programme, orientations, dispositif, status_lot } = useSelector((state) => state.deepsearchReducer);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadedImageEntries, setUploadedImageEntries] = useState([]);
  const [uploadedDocumentEntries, setUploadedDocumentEntries] = useState([]);
  const [documentTypes] = useState([
    { label: "règlement", value: "règlement" },
    { label: "plan de masse", value: "plan_masse" },
    { label: "plan de vente", value: "plan_vente" },
    { label: "plan etage", value: "plan_etage" },
    { label: "plaquette commerciale", value: "plaquette_commerciale" },
    { label: "contrat de réservation", value: "contrat_reservation" },
    { label: "autre", value: "other_documents" },
  ]);
  const [formData, setFormData] = useState({
    reference: null,
    programme_parent: null,
    typology: null,
    surface: null,
    price_total: null,
    rent: null,
    rent_profitability: null,
    weighted_surface: null,
    commission: null,
    price_vat_rate: null,
    type: null,
    origine: null,
    parking_price_incl_tax: null,
    price_excl_vat: null,
    parking_price_excl_vat: null,
    price_incl_tax: null,
    parking_price_vat_rate: null,
    parking_count: null,
    is_new: false,
    global_score: null,
    floor: null,
    geo_orientations: [],
    description: null,
    project_types: null,
    lastSync: null,
    city: null,
    disponibility: null,
    garden_surface: null,
    terrace_surface: null,
    loggia_surface: null,
    balcon_surface: null,
    cellar_surface: null,
    other_surface: null,
    land_deficit_ceil_boost_rate: null,
    renovation_price_excl_vat: null,
    renovation_price_incl_tax: null,
    renovation_price_vat_rate: null,
    url: null,
    price_m2: null,
    promoteur: null,
    longitude: null,
    latitude: null,
    usage: null,
    annexe: null,
    label: null,
    is_exclusive: null,
  });

  useEffect(() => {
    dispatch(fetchInitialData());
  }, [dispatch]);
  // Handle document selection
  const handleDocumentSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedDocuments((prev) => [
      ...prev,
      ...files.map((file) => ({
        file,
        type: "autre", // Default type
      })),
    ]);
  };
  // Remove document from selection
  const removeDocument = (index) => {
    setSelectedDocuments((prev) => prev.filter((_, i) => i !== index));
  };
  // Update document type
  const updateDocumentType = (index, type) => {
    setSelectedDocuments((prev) =>
      prev.map((doc, i) => (i === index ? { ...doc, type } : doc))
    );
  };
  const handleChange = (newFormData) => {
    setFormData(newFormData);
  };

  // Handle image selection
  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedImages((prev) => [...prev, ...files]);
  };

  // Remove image from selection
  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleImageUpload = async () => {
    setUploading(true);
    const uploadedEntries = [];

    try {
      // Process each selected image
      for (const file of selectedImages) {
        const reference = formData.reference || `temp-${Date.now()}`;
        const entry = await uploadAndCreateImageEntry(file, reference);
        if (entry) {
          uploadedEntries.push(entry);
        }
      }

      setUploadedImageEntries(uploadedEntries);
      toast.success(
        `${uploadedEntries.length} image(s) téléchargé(s) avec succès`
      );
      return uploadedEntries;
    } catch (error) {
      console.error("Error uploading images:", error);
      toast.error("Failed to upload one or more images");
      return [];
    } finally {
      setUploading(false);
    }
  };
  const handleDocumentUpload = async () => {
    setUploading(true);
    const uploadedEntries = [];

    try {
      // Process each selected document
      for (const doc of selectedDocuments) {
        const reference = formData.reference || `temp-${Date.now()}`;
        const entry = await uploadAndCreateDocumentEntry(
          doc.file,
          reference,
          doc.type
        );
        if (entry) {
          uploadedEntries.push(entry);
        }
      }

      setUploadedDocumentEntries(uploadedEntries);
      toast.success(
        `${uploadedEntries.length} document(s) téléchargé(s) avec succès`
      );
      return uploadedEntries;
    } catch (error) {
      console.error("Error uploading documents:", error);
      toast.error("Failed to upload one or more documents");
      return [];
    } finally {
      setUploading(false);
    }
  };

  // Submit form with images and documents already uploaded
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Required fields validation
      const errors = [];
      if (!formData.programme_parent) errors.push('Programme');
      if (!formData.reference || String(formData.reference).trim() === '') errors.push('Référence');
      if (formData.surface === null || formData.surface === '') errors.push('Surface (m²)');
      if (formData.price_total === null || formData.price_total === '') errors.push('Prix total');
      if (formData.rent === null || formData.rent === '') errors.push('Loyer');
      if (formData.commission === null || String(formData.commission).trim() === '') errors.push('Honoraires');

      if (errors.length > 0) {
        toast.error(`Champs requis manquants: ${errors.join(', ')}`);
        return;
      }

      setUploading(true);

      // Upload images if they haven't been uploaded yet
      let imageEntries = uploadedImageEntries;
      if (selectedImages.length > 0 && uploadedImageEntries.length === 0) {
        imageEntries = await handleImageUpload();
      }

      // Upload documents if they haven't been uploaded yet
      let documentEntries = uploadedDocumentEntries;
      if (
        selectedDocuments.length > 0 &&
        uploadedDocumentEntries.length === 0
      ) {
        documentEntries = await handleDocumentUpload();
      }
      // Prepare the property data with image and document links
      const dataToSend = {
        ...formData,
        lastSync: new Date().toISOString(),
        // Add the image IDs to connect with the property
        imageIds: imageEntries.map((entry) => entry.id),
        // Add the document IDs to connect with the property
        documentIds: documentEntries.map((entry) => entry.id),
      };

      const response = await mainAxios.post(`api/add-property`, dataToSend);

      toast.success("Lot ajouté avec succès");

      // Reset form after successful submission
      setFormData({
        programme_parent: null,
        reference: null,
        typology: null,
        surface: null,
        price_total: null,
        rent: null,
        rent_profitability: null,
        weighted_surface: null,
        commission: null,
        price_vat_rate: null,
        type: null,
        parking_price_incl_tax: null,
        price_excl_vat: null,
        parking_price_excl_vat: null,
        price_incl_tax: null,
        parking_price_vat_rate: null,
        parking_count: null,
        is_new: false,
        global_score: null,
        availability: null,
        floor: null,
        orientations: [],
        description: null,
        lastSync: null,
        city: null,
        disponibility: null,
        garden_surface: null,
        terrace_surface: null,
        loggia_surface: null,
        balcon_surface: null,
        cellar_surface: null,
        other_surface: null,
        land_deficit_ceil_boost_rate: null,
        renovation_price_excl_vat: null,
        renovation_price_incl_tax: null,
        renovation_price_vat_rate: null,
        url: null,
        price_m2: null,
        promoteur: null,
        commision_value: null,
        longitude: null,
        latitude: null,
        usage: null,
        annexe: null,
        label: null,
      });
      setSelectedImages([]);
      setUploadedImageEntries([]);
      setSelectedDocuments([]);
      setUploadedDocumentEntries([]);
    } catch (error) {
      //TODO SAIF FIX
      console.error("Erreur lors de l'ajout du lot:", error);
      toast.error("Erreur lors de l'ajout du lot");
    } finally {
      setUploading(false);
      dispatch(fetchLots());
      dispatch(closeModal());
    }
  };

  const [promoteurPagination, setPromoteurPagination] = useState(createPaginationState(50));
  const [lieuPagination, setLieuPagination] = useState(createPaginationState(30));

  const [programmePagination, setProgrammePagination] = useState(createPaginationState(50));
  // Handle loading more programme items when scrolling to bottom
  const handleProgrammeScrollToBottom = () => {
    handleScrollToBottom(programme, programmePagination, setProgrammePagination, 'name');
  };
  // Handle loading more promoteur items when scrolling to bottom
  const handlePromoteurScrollToBottom = () => {
    handleScrollToBottom(promoteur, promoteurPagination, setPromoteurPagination, 'name');
  };
  // Handle loading more lieu items when scrolling to bottom
  const handleLieuScrollToBottom = () => {
    handleScrollToBottom(lieu, lieuPagination, setLieuPagination, 'name');
  };
  // Handle lieu search input change
  const handleLieuInputChange = (inputValue) => {
    handleInputChange(inputValue, setLieuPagination);
  };
  // Handle promoteur search input change
  const handlePromoteurInputChange = (inputValue) => {
    handleInputChange(inputValue, setPromoteurPagination);
  };
  const handleProgrammeInputChange = (inputValue) => {
    handleInputChange(inputValue, setProgrammePagination);
  };
  // Calculate visible options for lieu
  const visibleLieuOptions = useMemo(() => {
    return getVisibleOptions(lieu, lieuPagination, 'name', 'id', 'name');
  }, [lieu, lieuPagination]);
  // Calculate visible options for programme
  const visibleProgrammeOptions = useMemo(() => {
    return getVisibleOptions(programme, programmePagination, 'name', 'id', 'name');
  }, [programme, programmePagination]);
  // Calculate visible options for promoteur
  const visiblePromoteurOptions = useMemo(() => {
    return getVisibleOptions(promoteur, promoteurPagination, 'name', 'id', 'name');
  }, [promoteur, promoteurPagination]);
  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div className="d-flex gap10">
          <div className="w60">
            <div className="form-row">
              <div className="form-group">
                <label>Programme<span className="text-danger">*</span></label>
                <Select
                  styles={customStyles}
                  options={visibleProgrammeOptions}
                  value={(() => {
                    const selectedId = Array.isArray(formData.programme_parent)
                      ? (formData.programme_parent[0] ?? null)
                      : formData.programme_parent ?? null;
                    return selectedId
                      ? visibleProgrammeOptions.find(opt => opt.value === selectedId) || null
                      : null;
                  })()}
                  onChange={(selectedOption) => {
                    handleChange({
                      ...formData,
                      programme_parent: selectedOption ? selectedOption.value : null,
                    });
                  }}
                  onMenuScrollToBottom={handleProgrammeScrollToBottom}
                  onInputChange={handleProgrammeInputChange}
                  placeholder="Selectionner..."
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? `Aucun programme trouvé pour "${inputValue}"` : "Tapez pour rechercher"
                  }
                  isSearchable={true}
                  filterOption={null} // Disable built-in filtering since we handle it manually
                />
              </div>
              <div className="form-group">
                <label htmlFor="">Promoteur</label>
                <Select
                  styles={customStyles}
                  options={visiblePromoteurOptions}
                  value={(() => {
                    const selectedId = Array.isArray(formData.promoteur)
                      ? (formData.promoteur[0] ?? null)
                      : formData.promoteur ?? null;
                    return selectedId
                      ? visiblePromoteurOptions.find(opt => opt.value === selectedId) || null
                      : null;
                  })()}
                  onChange={(selectedOption) => {
                    handleChange({
                      ...formData,
                      promoteur: selectedOption ? selectedOption.value : null,
                    });
                  }}
                  onMenuScrollToBottom={handlePromoteurScrollToBottom}
                  onInputChange={handlePromoteurInputChange}
                  placeholder="Selectionner..."
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? `Aucun promoteur trouvé pour "${inputValue}"` : "Tapez pour rechercher"
                  }
                  isSearchable={true}
                  filterOption={null} // Disable built-in filtering since we handle it manually
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Ville*</label>
                <Select
                  styles={customStyles}
                  options={visibleLieuOptions}
                  value={(() => {
                    const selectedId = Array.isArray(formData.city)
                      ? (formData.city[0] ?? null)
                      : formData.city ?? null;
                    return selectedId
                      ? visibleLieuOptions.find(opt => opt.value === selectedId) || null
                      : null;
                  })()}
                  onChange={(selectedOption) => {
                    handleChange({
                      ...formData,
                      city: selectedOption ? selectedOption.value : null,
                    });
                  }}
                  onMenuScrollToBottom={handleLieuScrollToBottom}
                  onInputChange={handleLieuInputChange}
                  placeholder="Selectionner..."
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? `Aucun lieu trouvé pour "${inputValue}"` : "Tapez pour rechercher"
                  }
                  isSearchable={true}
                  filterOption={null} // Disable built-in filtering since we handle it manually
                />
              </div>
              <div className="form-group">
                <label>Typologie</label>
                <Select
                  styles={customStyles}
                  options={[
                    { value: 't1', label: 'T1' },
                    { value: 't2', label: 'T2' },
                    { value: 't3', label: 'T3' },
                    { value: 't4', label: 'T4' },
                    { value: 't5', label: 'T5' },
                    { value: 't6', label: 'T6' },
                    { value: 't7', label: 'T7' },
                    { value: 't8', label: 'T8' },
                    { value: 't9', label: 'T9' },
                    { value: 't10', label: 'T10' }
                  ]}
                  value={formData.typology ?
                    [
                      { value: 't1', label: 'T1' },
                      { value: 't2', label: 'T2' },
                      { value: 't3', label: 'T3' },
                      { value: 't4', label: 'T4' },
                      { value: 't5', label: 'T5' },
                      { value: 't6', label: 'T6' },
                      { value: 't7', label: 'T7' },
                      { value: 't8', label: 'T8' },
                      { value: 't9', label: 'T9' },
                      { value: 't10', label: 'T10' }
                    ].find(option => Array.isArray(formData.typology)
                      ? formData.typology.includes(option.value)
                      : option.value === formData.typology)
                    : null}
                  onChange={(selectedOption) => {
                    handleChange({
                      ...formData,
                      typology: selectedOption ? selectedOption.value : null,
                    });
                  }}
                  placeholder="Selectionner..."
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="" className="mb-1">
                  Dispositif
                </label>
                <Select
                  styles={customStyles}
                  isMulti
                  options={dispositif?.map(item => ({ value: item.id, label: item.label })) || []}
                  value={
                    formData.project_types && formData.project_types.length > 0
                      ? dispositif?.filter(item => formData.project_types.includes(item.id)).map(item => ({ value: item.id, label: item.label })) || []
                      : []
                  }
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
                    handleChange({
                      ...formData,
                      project_types: selectedIds,
                    });
                  }}
                  placeholder="Selectionner..."

                />
              </div>

            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Type de lot</label>
                <Select
                  styles={customStyles}
                  options={[
                    { value: 'apartment', label: 'Appartement' },
                    { value: 'house', label: 'Maison' }
                  ]}
                  value={formData.type ?
                    [{ value: 'apartment', label: 'Appartement' }, { value: 'house', label: 'Maison' }]
                      .find(option => option.value === formData.type) : null}
                  onChange={(selectedOption) => {
                    handleChange({
                      ...formData,
                      type: selectedOption ? selectedOption.value : null,
                    });
                  }}
                  placeholder="Selectionner..."
                />
              </div>
              <div className="form-group">
                <label>Disponibilité</label>
                <Select
                  styles={customStyles}
                  options={status_lot?.map(item => ({ value: item.disponibilite, label: item.disponibilite })) || []}
                  value={formData.disponibility ?
                    { value: formData.disponibility, label: formData.disponibility } : null}
                  onChange={(selectedOption) =>
                    handleChange({
                      ...formData,
                      disponibility: selectedOption?.value || "",
                    })
                  }
                  placeholder="Selectionner..."
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Orientations</label>
                <Select
                  styles={customStyles}
                  isMulti
                  options={(orientations || []).map(o => ({ value: o.id, label: o.orientation }))}
                  value={(() => {
                    // Normalize current value to an array of ids
                    const current = Array.isArray(formData.geo_orientations)
                      ? formData.geo_orientations
                      : (formData.geo_orientations != null ? [formData.geo_orientations] : []);
                    const opts = (orientations || []).map(o => ({ value: o.id, label: o.orientation }));
                    return opts.filter(opt => current.includes(opt.value));
                  })()}
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                    handleChange({
                      ...formData,
                      geo_orientations: selectedIds,
                    });
                  }}
                  placeholder="Selectionner..."
                  isSearchable={true}
                />
              </div>
              <div className="form-group">
                <label>Étage</label>
                <Select
                  styles={customStyles}
                  options={[
                    { value: '0', label: '0' },
                    { value: '1', label: '1' },
                    { value: '2', label: '2' },
                    { value: '3', label: '3' },
                    { value: '4', label: '4' },
                    { value: '5', label: '5' },
                    { value: '6', label: '6' },
                    { value: '7', label: '7' },
                    { value: '8', label: '8' },
                    { value: '9', label: '9' }
                  ]}
                  value={
                    (formData.floor !== null && formData.floor !== undefined && formData.floor !== '')
                      ? [
                        { value: '0', label: '0' },
                        { value: '1', label: '1' },
                        { value: '2', label: '2' },
                        { value: '3', label: '3' },
                        { value: '4', label: '4' },
                        { value: '5', label: '5' },
                        { value: '6', label: '6' },
                        { value: '7', label: '7' },
                        { value: '8', label: '8' },
                        { value: '9', label: '9' }
                      ].find(option => option.value === String(formData.floor))
                      : null
                  }
                  onChange={(selectedOption) => {
                    handleChange({
                      ...formData,
                      floor: selectedOption ? selectedOption.value : null,
                    });
                  }}
                  placeholder="Selectionner..."
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Référence<span className="text-danger">*</span></label>
                <input
                  type="text"
                  name="reference"
                  value={formData.reference || ""}
                  onChange={(e) => handleChange({ ...formData, reference: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label>Surface (m²)<span className="text-danger">*</span></label>
                <input
                  type="number"
                  name="surface"
                  value={formData.surface || ""}
                  onChange={(e) => handleChange({ ...formData, surface: e.target.value })}
                  step="0.01"
                  min="0"
                  required
                />
              </div>

            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Loyer mensuel (€)<span className="text-danger">*</span></label>
                <input
                  type="number"
                  name="rent"
                  value={formData.rent || ""}
                  onChange={(e) => handleChange({ ...formData, rent: e.target.value })}
                  step="0.01"
                  min="0"
                  required
                />
              </div>
              <div className="form-group">
                <label>Prix total (€)<span className="text-danger">*</span></label>
                <input
                  type="number"
                  name="price_total"
                  value={formData.price_total || ""}
                  onChange={(e) => handleChange({ ...formData, price_total: e.target.value })}
                  min="0"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Rentabilité loyer (%)</label>
                <input
                  type="number"
                  name="rent_profitability"
                  value={formData.rent_profitability || ""}
                  onChange={(e) => handleChange({ ...formData, rent_profitability: e.target.value })}
                  step="0.01"
                  min="0"
                  max="100"
                />
              </div>
              <div className="form-group">
                <label>Surface pondérée (m²)</label>
                <input
                  type="number"
                  name="weighted_surface"
                  value={formData.weighted_surface || ""}
                  onChange={(e) => handleChange({ ...formData, weighted_surface: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>

            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Taux TVA prix (%)</label>
                <input
                  type="number"
                  name="price_vat_rate"
                  value={formData.price_vat_rate || ""}
                  onChange={(e) => handleChange({ ...formData, price_vat_rate: e.target.value })}
                  step="0.1"
                  min="0"
                  max="100"
                />
              </div>
              <div className="form-group">
                <label>Prix parking TTC (€)</label>
                <input
                  type="number"
                  name="parking_price_incl_tax"
                  value={formData.parking_price_incl_tax || ""}
                  onChange={(e) => handleChange({ ...formData, parking_price_incl_tax: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Prix HT (€)</label>
                <input
                  type="number"
                  name="price_excl_vat"
                  value={formData.price_excl_vat || ""}
                  onChange={(e) => handleChange({ ...formData, price_excl_vat: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Prix parking HT (€)</label>
                <input
                  type="number"
                  name="parking_price_excl_vat"
                  value={formData.parking_price_excl_vat || ""}
                  onChange={(e) => handleChange({ ...formData, parking_price_excl_vat: e.target.value })}
                  step="0.1"
                  min="0"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Prix TTC (€)</label>
                <input
                  type="number"
                  name="price_incl_tax"
                  value={formData.price_incl_tax || ""}
                  onChange={(e) => handleChange({ ...formData, price_incl_tax: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Taux TVA parking (%)</label>
                <input
                  type="number"
                  name="parking_price_vat_rate"
                  value={formData.parking_price_vat_rate || ""}
                  onChange={(e) => handleChange({ ...formData, parking_price_vat_rate: e.target.value })}
                  step="0.1"
                  min="0"
                  max="100"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Nombre de places parking</label>
                <input
                  type="number"
                  name="parking_count"
                  value={formData.parking_count || ""}
                  onChange={(e) => handleChange({ ...formData, parking_count: e.target.value })}
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Score global</label>
                <input
                  type="number"
                  name="global_score"
                  value={formData.global_score || ""}
                  onChange={(e) => handleChange({ ...formData, global_score: e.target.value })}
                  step="0.1"
                  min="0"
                  max="20"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Prix au m² (€)</label>
                <input
                  type="number"
                  name="price_m2"
                  value={formData.price_m2 || ""}
                  onChange={(e) => handleChange({ ...formData, price_m2: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>URL</label>
                <input
                  type="text"
                  name="url"
                  value={formData.url || ""}
                  onChange={(e) => handleChange({ ...formData, url: e.target.value })}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Surface jardin (m²)</label>
                <input
                  type="number"
                  name="garden_surface"
                  value={formData.garden_surface || ""}
                  onChange={(e) => handleChange({ ...formData, garden_surface: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Surface terrasse (m²)</label>
                <input
                  type="number"
                  name="terrace_surface"
                  value={formData.terrace_surface || ""}
                  onChange={(e) => handleChange({ ...formData, terrace_surface: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Surface loggia (m²)</label>
                <input
                  type="number"
                  name="loggia_surface"
                  value={formData.loggia_surface || ""}
                  onChange={(e) => handleChange({ ...formData, loggia_surface: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Surface balcon (m²)</label>
                <input
                  type="number"
                  name="balcon_surface"
                  value={formData.balcon_surface || ""}
                  onChange={(e) => handleChange({ ...formData, balcon_surface: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Surface cave (m²)</label>
                <input
                  type="number"
                  name="cellar_surface"
                  value={formData.cellar_surface || ""}
                  onChange={(e) => handleChange({ ...formData, cellar_surface: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Autre surface (m²)</label>
                <input
                  type="number"
                  name="other_surface"
                  value={formData.other_surface || ""}
                  onChange={(e) => handleChange({ ...formData, other_surface: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Majoration plafond déficit foncier (%)</label>
                <input
                  type="number"
                  name="land_deficit_ceil_boost_rate"
                  value={formData.land_deficit_ceil_boost_rate || ""}
                  onChange={(e) => handleChange({ ...formData, land_deficit_ceil_boost_rate: e.target.value })}
                  step="0.1"
                  min="0"
                  max="100"
                />
              </div>
              <div className="form-group">
                <label>Honoraires<span className="text-danger">*</span></label>
                <input
                  type="text"
                  name="commission"
                  value={formData.commission || ""}
                  onChange={(e) => handleChange({ ...formData, commission: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Prix rénovation HT (€)</label>
                <input
                  type="number"
                  name="renovation_price_excl_vat"
                  value={formData.renovation_price_excl_vat || ""}
                  onChange={(e) => handleChange({ ...formData, renovation_price_excl_vat: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
              <div className="form-group">
                <label>Prix rénovation TTC (€)</label>
                <input
                  type="number"
                  name="renovation_price_incl_tax"
                  value={formData.renovation_price_incl_tax || ""}
                  onChange={(e) => handleChange({ ...formData, renovation_price_incl_tax: e.target.value })}
                  step="0.01"
                  min="0"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Taux TVA rénovation (%)</label>
                <input
                  type="number"
                  name="renovation_price_vat_rate"
                  value={formData.renovation_price_vat_rate || ""}
                  onChange={(e) => handleChange({ ...formData, renovation_price_vat_rate: e.target.value })}
                  step="0.1"
                  min="0"
                  max="100"
                />
              </div>
              <div className="form-group">
                <label>Longitude</label>
                <input
                  type="number"
                  name="longitude"
                  value={formData.longitude || ""}
                  onChange={(e) => handleChange({ ...formData, longitude: e.target.value })}
                  step="0.000001"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Latitude</label>
                <input
                  type="number"
                  name="latitude"
                  value={formData.latitude || ""}
                  onChange={(e) => handleChange({ ...formData, latitude: e.target.value })}
                  step="0.000001"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Usage</label>
                <Select
                  styles={customStyles}
                  options={[
                    { value: 'RP', label: 'RP' },
                    { value: 'INVEST', label: 'INVEST' },
                    { value: 'RS', label: 'RS' },
                  ]}
                  value={formData.usage ? { value: formData.usage, label: formData.usage } : null}
                  onChange={(selectedOption) =>
                    handleChange({
                      ...formData,
                      usage: selectedOption ? selectedOption.value : null,
                    })
                  }
                  placeholder="Selectionner..."
                />
              </div>
              <div className="form-group">
                <label>Annexe</label>
                <Select
                  styles={customStyles}
                  options={[
                    { value: 'Parking exterieur', label: 'Parking exterieur' },
                    { value: 'Parking sous-sol', label: 'Parking sous-sol' },
                    { value: 'Garage', label: 'Garage' },
                    { value: 'Cave', label: 'Cave' },
                  ]}
                  value={formData.annexe ? { value: formData.annexe, label: formData.annexe } : null}
                  onChange={(selectedOption) =>
                    handleChange({
                      ...formData,
                      annexe: selectedOption ? selectedOption.value : null,
                    })
                  }
                  placeholder="Selectionner..."
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Label</label>
                <Select
                  styles={customStyles}
                  options={[
                    { value: 'RT 2012', label: 'RT 2012' },
                    { value: 'RE 2020', label: 'RE 2020' },
                    { value: 'Autre', label: 'Autre' },
                  ]}
                  value={formData.label ? { value: formData.label, label: formData.label } : null}
                  onChange={(selectedOption) =>
                    handleChange({
                      ...formData,
                      label: selectedOption ? selectedOption.value : null,
                    })
                  }
                  placeholder="Selectionner..."
                />
              </div>
              <div className="form-group">
                <label>Origine</label>
                <Select
                  styles={customStyles}
                  options={[
                    { value: 'interne', label: 'Interne' },
                    { value: 'externe', label: 'Externe' }
                  ]}
                  value={formData.origine ? { value: formData.origine, label: formData.origine === 'interne' ? 'Interne' : 'Externe' } : null}
                  onChange={(selectedOption) =>
                    handleChange({
                      ...formData,
                      origine: selectedOption ? selectedOption.value : null,
                    })
                  }
                  placeholder="Selectionner..."
                />
              </div>
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                type="text"
                name="description"
                value={formData.description || ""}
                onChange={(e) => handleChange({ ...formData, description: e.target.value })}
              />
            </div>
            <div className="form-row">
              <div className="form-group ">
                <label className="d-flex gap-2">
                  <input
                    type="checkbox"
                    name="is_new"
                    checked={formData.is_new}
                    onChange={(e) => handleChange({ ...formData, is_new: e.target.checked })}
                  />
                  Lot neuf
                </label>
              </div>
              <div className="form-group ">
                <label className="d-flex gap-2">
                  <input
                    type="checkbox"
                    name="is_exclusive"
                    checked={formData.is_exclusive || false}
                    onChange={(e) => handleChange({ ...formData, is_exclusive: e.target.checked })}
                  />
                  Exclusivité
                </label>
              </div>
            </div>
          </div>

          <div className="w40">
            {/* Images Section */}
            <div className="form-group d-flex flex-column">
              <label>Images</label>

              {/* Custom French button that triggers the hidden input */}
              <button
                type="button"
                className=" radius5 px-20 py-10 bg-pink text-white border-0 hoverOpacity"
                onClick={() => document.getElementById("image-input").click()}
              >
                Sélectionner des images
              </button>

              {/* Hidden actual file input */}
              <input
                id="image-input"
                type="file"
                accept="image/*"
                multiple
                onChange={handleImageSelect}
                className="d-none"
              />

              {selectedImages.length > 0 && (
                <div className="selected-images d-flex flex-column gap10 mt-2">
                  <p className="fw-bold mb-2">
                    Images sélectionnées ({selectedImages.length}):
                  </p>
                  <div className="image-previews d-flex flex-wrap gap10">
                    {selectedImages.map((file, index) => (
                      <div
                        key={index}
                        className="image-preview-item position-relative p-2 border rounded bg-light"
                      >
                        <p className="lot-image-name mb-0">{file.name}</p>
                        <button
                          type="button"
                          className="remove-image-btn position-absolute top-0 end-0 btn btn-sm text-danger"
                          onClick={() => removeImage(index)}
                          aria-label="Supprimer cette image"
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>

                  {uploadedImageEntries.length > 0 && (
                    <div className="upload-success mt-2">
                      <p className="text-success">
                        {uploadedImageEntries.length} image(s) téléchargée(s)
                        avec succès
                      </p>
                    </div>
                  )}

                  {!formData.reference && selectedImages.length > 0 && (
                    <p className="text-warning mt-2">
                      Veuillez remplir le champ "Référence" avant de télécharger
                      les images
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* Documents Section */}
            <div className="form-group d-flex flex-column mt-4">
              <label>Documents PDF</label>

              {/* Custom French button that triggers the hidden input */}
              <button
                type="button"
                className="radius5 px-20 py-10 bg-pink text-white border-0 hoverOpacity"
                onClick={() =>
                  document.getElementById("document-input").click()
                }
              >
                Sélectionner des documents PDF
              </button>

              {/* Hidden actual file input */}
              <input
                id="document-input"
                type="file"
                accept=".pdf"
                multiple
                onChange={handleDocumentSelect}
                className="d-none"
              />

              {selectedDocuments.length > 0 && (
                <div className="selected-documents d-flex flex-column gap10 mt-2">
                  <p className="fw-bold mb-2">
                    Documents sélectionnés ({selectedDocuments.length}):
                  </p>
                  <div className="document-previews d-flex flex-wrap gap10">
                    {selectedDocuments.map((doc, index) => (
                      <div
                        key={index}
                        className="document-preview-item position-relative p-2 border rounded bg-light"
                      >
                        <p className="lot-document-name mb-2">
                          {doc.file.name}
                        </p>
                        <div className="document-type-selector mb-1">
                          <select
                            value={doc.type}
                            onChange={(e) =>
                              updateDocumentType(index, e.target.value)
                            }
                            className="form-select form-select-sm"
                          >
                            {documentTypes.map((type) => (
                              <option key={type.value} value={type.value}>
                                {type.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <button
                          type="button"
                          className="remove-image-btn position-absolute top-0 end-0 btn btn-sm text-danger"
                          onClick={() => removeDocument(index)}
                          aria-label="Supprimer ce document"
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>

                  {uploadedDocumentEntries.length > 0 && (
                    <div className="upload-success mt-2">
                      <p className="text-success">
                        {uploadedDocumentEntries.length} document(s)
                        téléchargé(s) avec succès
                      </p>
                    </div>
                  )}

                  {!formData.reference && selectedDocuments.length > 0 && (
                    <p className="text-warning mt-2">
                      Veuillez remplir le champ "Référence" avant de télécharger
                      les documents
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={uploading}
          className={`radius5 px-20 py-10 text-white border-0 hoverOpacity ${uploading ? "bg-soft-grey" : "bg-pink"
            }`}
        >
          {uploading ? "En cours..." : "Enregistrer le lot"}
        </button>
      </form >
    </div >
  );
};

export default AjouterLot;
